import type { TweetListResponsePageAllOfThreeContentItem } from './tweetListResponsePageAllOfThreeContentItem';

export type TweetListResponsePageAllOfThree = {
  content?: TweetListResponsePageAllOfThreeContentItem[];
};
